import React from 'react';
import { ShippingBanner } from '../components/ShippingBanner';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Breadcrumb } from '../components/product/Breadcrumb';
import { ProductGallery } from '../components/product/ProductGallery';
import { ProductInfo } from '../components/product/ProductInfo';
import { RelatedProducts } from '../components/product/RelatedProducts';
export function ProductPage() {
  return <div className="min-h-screen flex flex-col bg-[#FAFAFA]" data-id="element-984">
      <ShippingBanner data-id="element-985" />
      <Navbar data-id="element-986" />

      <main className="flex-grow" data-id="element-987">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-988">
          <Breadcrumb category="Dresses" productName="The Silk Wrap Dress" data-id="element-989" />

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 pb-16" data-id="element-990">
            {/* Gallery - constrained width on desktop */}
            <div className="lg:max-w-md" data-id="element-991">
              <ProductGallery data-id="element-992" />
            </div>

            {/* Product Info */}
            <div className="lg:pt-2" data-id="element-993">
              <ProductInfo data-id="element-994" />
            </div>
          </div>
        </div>

        <RelatedProducts data-id="element-995" />
      </main>

      <Footer data-id="element-996" />
    </div>;
}